dealershipModule.controller('DealerPackController',
    ['$scope','$rootScope', '$q', 'dealerPackService','profitSettingsService', 'DealerPack', 'dealershipModuleConstants','TLCError','AppErrorCodes',
    function ($scope, $rootScope, $q, dealerPackService,profitSettingsService, DealerPack, dealershipModuleConstants,TLCError,AppErrorCodes) {
        // private constants:
        var duplicates = { allowed: "DUPLICATE", notAllowed: "UNIQUE" };

        // passed in via directive attributes: $scope.product
        $scope.loading = false;
        $scope.isStateRegulated = false;
        $scope.isMarkupAllowed = false;

        makeModelClean();

        $scope.init = function() {

            $scope.loading = true;


            var promises = [
                dealerPackService.getProviderTermLabelSets(),
                dealerPackService.getProviderPackSettings(),
                dealerPackService.getDealerPacks($scope.product.productCode, Date.today()),
                profitSettingsService.getProfitSetting($scope.product.productCode, Date.today()),
                dealerPackService.getMarkUpAllowed()
            ];

            $q.all(promises)
                .then(function(promisedResults) {
                    $scope.termLabelSets = promisedResults[0];
                    var providerPackSettings = promisedResults[1];
                    $scope.packs = promisedResults[2];
                    $scope.profSettings = promisedResults[3];
                    $scope.allowMarkUp = promisedResults[4];

                    $scope.currentTermLabelSet = DealerPack.lookupTermLabelSet($scope.product.productTypeCode, $scope.termLabelSets);
                    $scope.areDuplicatesAllowed = providerPackSettings.duplication && providerPackSettings.duplication === duplicates.allowed;

                    if ($scope.packs.length == 0) {
                        // Make sure there is at least one row
                        $scope.addNewEmptyPack();
                    }

                    if($scope.profSettings != undefined ){
                       $scope.isStateRegulated = ($scope.profSettings.type == "StateRegulated" ? true : false);
                       $scope.isMarkupAllowed = $scope.isStateRegulated == true ? $scope.allowMarkUp : false;
                    }

                    $scope.originalPacks = angular.copy($scope.packs);
                    $scope.loading = false;
                },
                function (error) {
                    $scope.loading = false;
                    // any errors that occurred have already been logged.
                    throw new TLCError(new Error(error),AppErrorCodes.DealerPackController_GeneralError);
                }
            )
        }

        // Call this to see if a given pack, presumed to be in the view, is the dummy row used to create new pack items.
        $scope.checkNewRow = function(pack) {
             if (pack.isPersistable()) {
                 return;
            }

            // The pack in question is not persistable, so it must be the "dummy" pack, used for creating new packs.
            // In that case, make it persistable and add a new dummy row to take its place.
            pack.ensurePersistable();
            pack.effectiveDate = Date.today();
            // convert null amounts to zero.
            pack.markups = pack.markups.map(function(markup) {return  {key: markup.key, amount: 0.00};});
            //addNewEmptyPack();
        }

        $scope.canBeDeleted = function(pack) {
            if (pack.isPersistable()) {
                return true;
            }

            // Attempting to delete the "empty" row. OK, as long as it isn't the ONLY row left.
            return $scope.packs.length > 1;
        }

        // Persists dealer packs
        $scope.saveDealerPacks = function() {
            notifyDone();
            if (angular.equals($scope.packs, $scope.originalPacks)) {
                return;
            }

            var hashSet = {};

            var persistablePacks = $scope.packs.filter(function(pack) { return pack.isPersistable(); });
            var dupDateStr = persistablePacks.reduce(function(result, pack) {
                if (pack.isPersistable()) {
                    var date = pack.effectiveDate.mmddyyyy();
                    result = result || (hashSet[date] ? date : "");  // keep date iff already in hash set
                    hashSet[date] = true; // yeah, it's a side effect. But it's close by.
                }
                return result;
            }, "");

            if (dupDateStr) {
                return;
            }

            dealerPackService.updateDealerPacks($scope.product.productCode, Date.today(), persistablePacks)
            .then(function(data) {
                makeModelClean();
                $rootScope.$broadcast(dealershipModuleConstants.RERATE_PRODUCT, {productId: $scope.product.productCode});
            },
            function(error) {
                makeModelClean();
            });
        };

        $scope.onDeletePack = function(index) {
            // remove from view
            var deleted = $scope.packs.splice(index,1);
            if ($scope.packs.length == 0) {
                $scope.addNewEmptyPack();
            }

            // if the item originated from the DB, keep track of it, so we can delete it from the DB.
            if (deleted && deleted.length > 0 && deleted[0].isFromDB()) {
                $scope.deletions.push(deleted[0]);
            }
        };

          $scope.cancelEdit = function() {
            makeModelClean();
        };

        $scope.haveEmptyPack = function(){
            var emptyPack = $scope.packs.find(function(elem, index, array){
                if (!elem.effectiveDate){ return true; }
                return false;
            });
            return (emptyPack != undefined && emptyPack!= null);
        }

        $scope.isLast = function(row) {
            //console.log(row + " / " + $scope.packs.length);
            return $scope.packs.length == row + 1;
        }


        $scope.getLabel = function(index) {
            var terms = $scope.currentTermLabelSet.terms || [];
            if (terms.length <= 1) {
                return "";   // Don't need label if there's only one
            }

            // currentTermLabelSet.terms[index].label  or "" if anything undefined
            return (terms[index] || {}).label || "";
        }

        $scope.addNewEmptyPack = function(){
            var emptyPack = new DealerPack();
            emptyPack.productCode = $scope.product.productCode;
            emptyPack.productTypeCode = $scope.productTypeCode;
            emptyPack.setMarkupKeys($scope.termLabelSets);
            $scope.packs.push(emptyPack);
        }

        function makeModelClean() {
            $scope.packs = [];
            $scope.originalPacks = [];
            $scope.areDuplicatesAllowed = false;  // expose for testing, provider dependent

            $scope.termLabelSets = []; // expose for testing
            $scope.currentTermLabelSet = {};

            $scope.deletions = [];
            $scope.modelIsDirty = false;
        }

        function notifyDone(msg) {
            if (msg && msg.error) {
                throw new TLCError(new Error(msg.error),AppErrorCodes.DealerPackController_GeneralError);
            }
            if ($scope.promiseSave) {
                $scope.promiseSave.resolve();
            }
        }

        $scope.$on('productSettingsSave', function(e) {
            $scope.saveDealerPacks();
        });

        $scope.$on('productSettingsCancel', function(e) {
            $scope.cancelEdit();
        });


        $scope.init();
    }
]);
